const $inject = [];

const currentUserService = () => {
  const service = {};
  const namespace = 'CURRENT_USER';

  service.store = store;
  service.get = get;
  service.clear = clear;
  service.isConsultant = isConsultant;

  function store(key, value) {
    if(key === 'debtor') {
      window.svelteStore.userDebtor.set(value);
      localStorage.setItem('activeDebtor', value.Name);
    } else {
      sessionStorage.setItem(`${namespace}_${key}`, JSON.stringify(value));
      if (value && value.IsFromAuth0) {
        sessionStorage.setItem('IsFromAuth0', value.IsFromAuth0);
      }
    }

    return get(key);
  }

  function get(key) {
    const storedItem = sessionStorage.getItem(`${namespace}_${key}`);
    return storedItem ? JSON.parse(storedItem) : null;
  }

  function clear(key) {
    if(key) {
      sessionStorage.removeItem(`${namespace}_${key}`);
    } else {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith(namespace)) {
          sessionStorage.removeItem(key);
        }
      });
    }
  }

  function isConsultant() {
    const userInfo = get('userInfo');
    let _isConsultant = userInfo && userInfo.Role === 'Consultant';
    if (_isConsultant) localStorage.setItem('isConsultant', true);
    return _isConsultant;
  }

  return service;
};

currentUserService.$inject = $inject;

export default currentUserService;



// WEBPACK FOOTER //
// ./src/services/currentUserService.js